import { render, staticRenderFns } from "./DesktopProductItem.vue?vue&type=template&id=652944b1&scoped=true"
import script from "./DesktopProductItem.vue?vue&type=script&lang=js"
export * from "./DesktopProductItem.vue?vue&type=script&lang=js"
import style0 from "./DesktopProductItem.vue?vue&type=style&index=0&id=652944b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652944b1",
  null
  
)

export default component.exports